import { render, staticRenderFns } from "./ContentTabHackathon.vue?vue&type=template&id=5adad580&scoped=true"
import script from "./ContentTabHackathon.vue?vue&type=script&lang=js"
export * from "./ContentTabHackathon.vue?vue&type=script&lang=js"
import style0 from "./ContentTabHackathon.vue?vue&type=style&index=0&id=5adad580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adad580",
  null
  
)

export default component.exports